import { tsv } from "@faire/slate/lib/tsv";
import { cn } from "@faire/web/tools/cn";
import * as React from "react";

interface IProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  strokeWidth: number;
  size?: string | number;
}

/**
 * @trackcomponent
 */
export const BaseSpinner: React.FC<IProps> = ({
  className,
  color,
  strokeWidth,
  size,
  ...props
}) => {
  const circleVars = circleStyles.vars({ color });
  return (
    <svg
      className={cn("fs-spinner", className)}
      viewBox="25 25 50 50"
      height={size}
      width={size}
      {...props}
    >
      <circle
        className="fs-spinner__circle"
        cx="50"
        cy="50"
        fill="none"
        r="20"
        style={circleVars}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

const circleStyles = tsv({
  vars: {
    color: "fs-spinner-color",
  },
});
